import { reactive } from 'vue'

export const rPepDefaultValues = {
	RBR_presets: 'ASHSTD',
	gpdppptionsBR: 'ecoMark',
	caBedroom: false,
	nBR0: 0,
	nBR1: 0,
	nBR2: 0,
	nBR3: 0,
	nBR4: 0,
	nBR5: 0,
}

export const defaultFormDataValues = {
	buildingType: 'multi_family',
	nPeople: null,
	nApt: null,
	gpdpp : 25,
	CAspec: false,
	inputmethod: 'NPep',
	// Custom Load fields
	customLoadMethod: 'ignCL',  // 'onlyCL' | 'addCL' | 'ignCL'
	customLoad_00: 0,
	customLoad_01: 0,
	customLoad_02: 0,
	customLoad_03: 0,
	customLoad_04: 0,
	customLoad_05: 0,
	customLoad_06: 0,
	customLoad_07: 0,
	customLoad_08: 0,
	customLoad_09: 0,
	customLoad_10: 0,
	customLoad_11: 0,
	customLoad_12: 0,
	customLoad_13: 0,
	customLoad_14: 0,
	customLoad_15: 0,
	customLoad_16: 0,
	customLoad_17: 0,
	customLoad_18: 0,
	customLoad_19: 0,
	customLoad_20: 0,
	customLoad_21: 0,
	customLoad_22: 0,
	customLoad_23: 0,
	incomingT: 50,
	supplyT: 125,
	storageT: 150,
	lsNorm_TempSetOffTrig: 140,
	lsShed_TempSetOffTrig: 140,
	lsLoadUp_TempSetOffTrig: 140,
	lsLoadUp_TempSetHPWHOut: 160,
	lsShed_TempSetHPWHOut: 150,
	aquastatFraction: 40,
	percentUseable: 85,
	schematic: 'swingtank',
	RLHLmethod: 'Watts/Apt.',
	Wapt: 100,
	recircTemp: 120,
	TMSafetyFactor: 1.75,
	TMonTemp: 125,
	setpointTM: 135,
	offTime: 0.33,
	primaryStorageVol_G: null,
	primaryHeatingCap_kBTUh: null,
	gasHeater_AquaFrac: 80,
	gasHeater_OffSensor: 40,
	gasHeater_TempSetOnTrig: 125,
	gasHeater_TempSetOffTrig: 130,
	gasHeater_TempSetHPWHOut: 150,
	advancedControls: false,
	loadShiftToggled: false,
	loadShift_percent: 95,
	LSperiod1_bool: false,
	LSperiod1: [6, 10],
	LSperiod2_bool: false,
	LSperiod2: [16, 21],
	lsNorm_TempSetOnTrig: 115,
	offSensor_normal: 35,
	lsLoadUp_AquaFrac: 20,
	lsLoadUp_OffSensor: 15,
	lsLoadUp_TempSetOnTrig: 115,
	lsShed_AquaFrac: 80,
	lsShed_OffSensor: 55,
	lsShed_TempSetOnTrig: 115,
	loadup_hours: 3,
	PCap_kW: null,
	numHeatPumps: 1,
	defrost_derate: 1.0,
	sizeAdditionalER: false,
	errors: false,  // Used to trigger Advanced Schematic Options panel open on recircFlow error
	... rPepDefaultValues,
}

export default reactive({})
